import { Drawer, Modal } from "antd";

Modal.defaultProps = { ...Modal.defaultProps, maskClosable: false };
Drawer.defaultProps = { ...Drawer.defaultProps, maskClosable: false };
